/* 学生端 路由 */
export default[
  // 学生空间
  {
    path: "/user",
    name: "user",
    component: () => import("@/views/studentSide/userCenter/layout"),
    redirect: "/user/project",
    children:[
      // 我的项目
      {
        path: "/user/project",
        name: "userProject",
        component: () => import("@/views/studentSide/userCenter/project"),
      },
      // 个人信息
      {
        path: "/user/message",
        name: "userMessage",
        component: () => import("@/views/studentSide/userCenter/message"),
      }
    ]
  },
  {
    path: "/project",
    name: "project",
    component: () => import("@/views/studentSide/project/layout"),
    redirect: "/project/mustCourse",
    children:[
      // 必修课程
      {
        path: "/project/mustCourse",
        name: "projectMustCourse",
        component: () => import("@/views/studentSide/project/mustCourse"),
      },
      // 选修课程
      {
        path: "/project/selectCourse",
        name: "projectSelectCourse",
        component: () => import("@/views/studentSide/project/selectCourse"),
      },
      // 公共资源课程
      {
        path: "/project/publicResourceCourse",
        name: "publicResourceCourse",
        component: () => import("@/views/studentSide/project/publicResourceCourse"),
      },
      // 我的笔记
      {
        path: "/project/task",
        name: "projectTask",
        component: () => import("@/views/studentSide/project/task"),
      },
      {
        path: "/project/task/content",
        name: "projectTaskContent",
        component: () => import("@/views/studentSide/project/taskContent"),
      },
      // 我的作业 培训成果  培训总结
      {
        path: "/project/work",
        name: "projectWork",
        component: () => import("@/views/studentSide/project/work"),
      },
      // 培训成果
      {
        path: "/project/achievement",
        name: "projectAchievement",
        component: () => import("@/views/studentSide/project/achievement"),
      },
      // 培训总结
      {
        path: "/project/summary",
        name: "projectSummary",
        component: () => import("@/views/studentSide/project/summary"),
      },
      // 我的档案
      {
        path: "/project/file",
        name: "projectFile",
        component: () => import("@/views/studentSide/project/file"),
      },
      // 主题研讨
      {
        path: "/project/seminar",
        name: "projectSeminar",
        component: () => import("@/views/studentSide/project/seminar"),
      },
      // 辅助资料
      {
        path: "/project/assist",
        name: "projectAssist",
        component: () => import("@/views/studentSide/project/assist"),
      },
      // 辅助工具
      {
        path: "/project/tool",
        name: "projectTool",
        component: () => import("@/views/studentSide/project/tool"),
      },
      // 电子证书
      {
        path: "/project/certificate",
        name: "projectCertificate",
        component: () => import("@/views/studentSide/project/certificate"),
      },
      // 问卷调查
      {
        path: "/project/paper",
        name: "projectPaper",
        component: () => import("@/views/studentSide/project/paper"),
      },
      {
        path: "/project/paperTest",
        name: "projectPaperTest",
        component: () => import("@/views/studentSide/project/paperTest"),
      },
      // 内容页
      {
        path: "/project/contentShow",
        name: "projectContentShow",
        component: () => import("@/views/studentSide/components/ContentShow"),
      },
      // 历史记录表格
      {
        path: "/project/historyTable",
        name: "projectHistoryTable",
        component: () => import("@/views/studentSide/components/HistoryTable"),
      },
      // 主题研讨
      {
        path: "/project/seminarContent",
        name: "seminarContent",
        component: () => import("@/views/studentSide/components/SeminarContent"),
      }
    ]
  },
  {
    path: "/project/video",
    name: "projectVideo",
    component: () => import("@/views/studentSide/project/video")
  },
]



// WEBPACK FOOTER //
// ./src/router/studentSide.js